const redirects: Record<string, string> = {
  '/topics/': '/topic/',
}

export default defineNuxtRouteMiddleware(async (to) => {
  for (const [oldPath, newPath] of Object.entries(redirects)) {
    if (to.fullPath.match(oldPath))
      return navigateTo(to.fullPath.replace(oldPath, newPath))
  }

  const enterprise = useEnterprise()
  if (!to.query.enterprise_id && enterprise.value !== 1) {
    // Checks if url already has queries or not
    const querySymbol = Object.entries(to.query).length === 0 ? '?' : '&'

    return navigateTo(`${to.fullPath}${querySymbol}enterprise_id=${enterprise.value}`)
  }
})
